import { Model } from '@vuex-orm/core'

import { Material } from './Material'

export default class Journal extends Model {
  static entity = 'journals'

  static fields () {
    return {
      id: this.attr(null),
      text: this.attr(null),
      meta: this.attr(null),
      topic: this.attr(null),
      revisions: this.attr(null),
      materials: this.hasMany(Material, 'journal_id'),
    }
  }
}
